export const statsData = [
  {
    id: 1,
    value: 5,
    label: "Total Companies",
  },
  {
    id: 2,
    value: 113,
    label: "Documents Processed",
  },
  {
    id: 3,
    value: "63%",
    label: "Avg DD Progress",
  },
  {
    id: 4,
    value: 1,
    label: "High Risk Companies",
  },
];
